import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'

import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'

import './shared/translations/i18next'
import App from './screens/App/App'
import { rootReducer } from './store/root.reducer'
import { rootSaga } from './store/root.sagas'

const sagaMiddleware = createSagaMiddleware()

const rootStore = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)

sagaMiddleware.run(rootSaga)

export default function Bootstrap (): React.ReactElement {
  return (
    <Provider store={rootStore}>
      <Router basename='/'>
        <App />
      </Router>
    </Provider>
  )
}

const container = window.document.getElementById('root')
const root = createRoot(container!)
root.render(<Bootstrap />)

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister()
  })
}